/**
 * Image assets from Figma design.
 *
 * These files are stored in the /public/assets/ folder and served as static assets.
 *
 * Usage:
 *   import { HERO_BG, INTRO_LANDSCAPE } from '@config/assets';
 *   <img src={HERO_BG} alt="…" />
 */

/* ---- Hero ---- */
export const HERO_BG =
  '/assets/images/48c77c35-30bb-440b-b419-66b27b5b1a4e.png';

/* ---- Intro section ---- */
export const INTRO_LANDSCAPE =
  '/assets/images/9462c17a-308a-44b7-8f62-3169e5650a5d.png';

/* ---- Pourquoi section ---- */
export const POURQUOI_IMAGE =
  '/assets/images/3bbd5c79-8852-4672-8e7d-c4e9de5f0477.png';

/* ---- Notre action section (3 images, one per row) ---- */
/* Structurer la production – right side, 438×292, r:22 */
export const ACTION_IMAGE =
  '/assets/images/7bbee485-65f7-4d85-ac40-fd459f21d4a3.png';

/* Garantir la qualité – left side, 628×269, r:27 */
export const ACTION_GARANTIR =
  '/assets/images/1f27f7c5-1a5d-440c-a9da-afca6854bf29.png';

/* Connecter les marchés – right side, 547×365, r:28 */
export const ACTION_CONNECTER =
  '/assets/images/1f93c1d1-7ca2-4a31-bbb3-055bc02a93b1.png';

/* ---- Nos produits ---- */
export const PRODUCT_PIMENTS =
  '/assets/images/8660f10e-6d6b-43b4-a4d0-b005673b5bdc.png';

export const PRODUCT_GOMBO =
  '/assets/images/e16fd596-ea32-466c-a28e-30b3afbf7be4.png';

export const PRODUCT_CACAHOUETES =
  '/assets/images/4af2f098-cad2-4dbc-9aec-dede0cab2f30.png';

/* ---- Gallery ---- */
export const GALLERY_LEFT =
  '/assets/images/c02dbbee-2eab-4a05-bb6a-d0953ba3c8a2.png';

export const GALLERY_RIGHT =
  '/assets/images/aab0e9bb-01e9-46f0-a678-15da8e2a8c74.png';

/* ---- Nos origines page – Header photos ---- */
export const ORIGINES_HEADER_LEFT =
  '/assets/images/a7a2e451-c9f6-4b11-b418-33e5bf680fa6.png';

export const ORIGINES_HEADER_RIGHT =
  '/assets/images/0a697b43-8927-4285-a188-bd2cb57bcb5c.png';

/* ---- Nos origines page – Notre réseau photos ---- */
export const ORIGINES_RESEAU_WIDE =
  '/assets/images/fdbb2b73-427a-4c37-a2f5-349ec7586669.png';

export const ORIGINES_PORTRAIT =
  '/assets/images/image 18.png';

export const ORIGINES_FARMER =
  '/assets/images/e7196a0e-e36d-42a8-8c03-5f2cb85e7ece.png';

/* ---- Nos origines page – Impact background ---- */
export const ORIGINES_IMPACT_BG =
  '/assets/images/88634d96-0c55-4dfe-a9a2-5bf40ed8e8a7.png';

/* ---- Nos origines page – Icons ---- */
export const ICON_GLOBE =
  '/assets/icons/da7a9ac6-8706-412c-82dd-4852fdf615f5.svg';

export const ICON_PLANT =
  '/assets/icons/c375524c-f086-4367-b4b4-e3c0aaa99fe5.svg';

export const ICON_AVATAR =
  '/assets/icons/83cc56e0-c5a2-4382-b1cc-1bb56cfd13ea.svg';

export const ICON_CALENDAR =
  '/assets/icons/97a41fa9-c51f-4ac2-be29-105e54d20966.svg';

/* ---- Footer social icons ---- */
export const ICON_SOCIAL_1 =
  '/assets/icons/01e17f4a-1fa8-4c34-a7b8-f7304ba2e5a4.svg';

export const ICON_SOCIAL_2 =
  '/assets/icons/23b84052-3cdc-4c14-ba8b-2ed64c443daa.svg';

export const ICON_SOCIAL_3 =
  '/assets/icons/853ea360-545a-49ad-b74e-19194bbc44f8.svg';

export const ICON_SOCIAL_4 =
  '/assets/icons/3d5de0e0-c60e-43f5-8f0d-c0403a8511bc.svg';

/* ---- Rejoindre le réseau page – Section images ---- */
export const REJOINDRE_AGRICULTEUR =
  '/assets/images/8fa2f53f-471b-49a3-a409-f798d5e77113.png';

export const REJOINDRE_DISTRIBUTEUR =
  '/assets/images/195b8312-5d63-4d8f-a0d6-b0d72e40ae08.png';

/* ---- Devenir partenaire page ---- */
export const CONTACT_IMAGE =
  '/assets/images/ec34f036-9c82-4494-9800-037cfb4a7687.png';
